import React from 'react';
import { Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0a0f1c] py-12 border-t border-white/5" data-id="element-170" data-mp="3gf96f0gd6eb2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171" data-mp="3ggkal1dq1o2p">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-172" data-mp="32ovukn0cqfgg">
          <div className="text-center md:text-left" data-id="element-173" data-mp="36oo9dhgc9hu9">
            <a href="#" className="font-display text-2xl tracking-wider text-white mb-2 block" data-id="element-174" data-mp="36nd1p6jrvpxv">
              PALM BEACH <span className="text-orange" data-id="element-175" data-mp="38z6mkvj6mzq">POWERSTROKE</span>
            </a>
            <p className="text-slate-500 text-sm" data-id="element-176" data-mp="3lelzi2xtwhm3">
              The authority in diesel and Powerstroke repair.
            </p>
          </div>

          <div className="flex items-center space-x-6" data-id="element-177" data-mp="3qbvmlbxqwh6r">
            <a href="#" className="text-slate-500 hover:text-orange transition-colors text-sm font-medium" data-id="element-178" data-mp="29ynmxp3fzdg4">
              Terms
            </a>
            <a href="#" className="text-slate-500 hover:text-orange transition-colors text-sm font-medium" data-id="element-179" data-mp="3l9k7pidf7xfx">
              Privacy
            </a>
            <a href="#contact" className="text-slate-500 hover:text-orange transition-colors text-sm font-medium" data-id="element-180" data-mp="3gcts0w5j33v1">
              Contact
            </a>
            <a href="https://instagram.com/PalmBeachPowerstroke" target="_blank" rel="noopener noreferrer" aria-label="Follow Palm Beach Powerstroke on Instagram" className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/5 border border-white/10 text-slate-400 hover:bg-orange hover:border-orange hover:text-white transition-all" data-id="element-181" data-mp="3qapwx67vh2kp">
              <Instagram className="w-5 h-5" data-id="element-182" data-mp="qsqd43f7wmrc" />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white/5 text-center md:text-left text-slate-600 text-sm" data-id="element-183" data-mp="msg7irvc7yd0">
          &copy; {new Date().getFullYear()} Palm Beach Powerstroke. All rights
          reserved.
        </div>
      </div>
    </footer>;
}